/* eslint-disable */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useMemo, useState } from 'react';
import { INotification } from 'src/interfaces';
import { HorizonDropdown } from 'pg-ui-library';
import NotificationsService from 'src/services/notifications.service';
import { useMutation } from '@tanstack/react-query';
import { EyeIcon, EyeIconButton, HeaderContainer, TableContainer, RightHeaderContainer1 } from './styles';
import { DefaultTable } from '../default-table';
import { DistributionModal } from '../distribution-modal';

import { useActions } from 'src/hooks/useActions';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { HeaderText } from 'src/modules/dashboard/styles';
import close from 'src/assets/close.svg';

interface INotificationTable {
  tableData: INotification[];
}

const sortBy = [
  {
    key: 'sort01',
    label: 'Date',
    value: 'Date',
  },
  {
    key: 'sort02',
    label: 'Manager',
    value: 'Manager',
  },
];

const module = [
  {
    key: 'mod01',
    label: 'Default',
    value: '',
  },
];

const messageType = [
  {
    key: 'mType01',
    label: 'All',
    value: '',
  },
  {
    key: 'mType02',
    label: 'Task',
    value: 'Task',
  },
  {
    key: 'mType03',
    label: 'Notification',
    value: 'Notification',
  },
  {
    key: 'mType04',
    label: 'Distribution',
    value: 'Distribution',
  },
  {
    key: 'mType05',
    label: 'New Hire',
    value: 'New Hire',
  },
];

const activeType = [
  {
    key: 'all',
    label: 'All',
    value: 'All',
  },
  {
    key: 'active',
    label: 'Active',
    value: 'Active',
  },
  {
    key: 'inactive',
    label: 'Inactive',
    value: 'Inactive',
  },
];

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      font: 'normal normal bold 16px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 14px Biotif',
      color: '#1B1D35',
      borderRadius: '5px',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  cells: {
    style: {
      justifyContent: 'left',
      '&:nth-of-type(5)': {
        justifyContent: 'left',
      },
    },
  },
  pagination: {
    style: {
      border: 'none',
    },
  },
};

export const NotificationsTable: React.FC<INotificationTable> = ({ tableData }) => {
  const navigate = useNavigate();
  const [messageValue, setMessageValue] = useState<string>('');
  const [sortValue, setSortValue] = useState<string>('Date');
  const [moduleValue, setModuleValue] = useState<string>('');
  const [activeValue, setActiveValue] = useState<string>('');
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [items, setData] = useState<any>();
  const { getNotifications } = useActions();
  const handleModalClose = () => {
    setIsOpen(false);
  };
  const openButtonWrapper = (updateFunction: Function, row: INotification) => (
    <EyeIconButton
      onClick={() => {
        updateFunction();
      }}
    >
      <img src={close} alt="close" style={{ width: 12, height: 12 }} />
    </EyeIconButton>
  );

  // const openButtonWrapper = (updateFunction: Function, row: INotification) => (
  //   <EyeIconButton
  //     onClick={e => {
  //       // if (row.type === 'New Hire' || row.type === 'Open Enrollment') {
  //       //   navigate('/benefits');
  //       // }
  //       // if (row.type === 'W2') {
  //       //   navigate('/tax-forms');
  //       // }
  //       // setIsOpen(true);
  //       updateFunction();
  //     }}
  //   >
  //      <CloseIcon style={{ fontSize: 24, color: '#373A90' }} />
  //   </EyeIconButton>
  // );

  const columns = useMemo(
    () => [
      {
        name: 'Type',
        selector: (row: INotification) => row.type,
        sortable: true,
        width: '147px',
      },
      {
        name: 'Date',
        selector: (row: INotification) => row.createdAt,
        sortable: true,
        sortField: 'date',
        width: '120px',
      },
      {
        name: 'Message',
        selector: (row: INotification) => row.module,
        sortable: true,
        width: '365px',
        wrap: true,
      },
      {
        name: 'Manage/Employee',
        selector: (row: INotification) => row.manager,
        sortable: true,
        sortField: 'Manage',
        width: '165px',
      },
      {
        selector: (row: INotification) => row.manager,
        sortable: true,
        width: '100px',
        cell: (row: INotification) => openButtonWrapper(() => updateNotificationStatus(row.id), row),
      },
    ],
    []
  );

  const mutation = useMutation((notificationId: string) => NotificationsService.updateNotifications(notificationId));

  const updateNotificationStatus = async (notificationId: string) => {
    try {
      await mutation.mutateAsync(notificationId);
      getNotifications();
    } catch (error) {}
  };

  const mountTableData = (data: INotification[]) => {
    const tableRow = data
      ? data.map((item: INotification) => ({
          ...item,
          benefits: `$ ${item?.benefits}`,
        }))
      : '';
    setData(tableRow);
  };

  const sortData = (notificationItems: INotification[], value: string) =>
    notificationItems.sort((a, b) =>
      value === 'Manager' ? (a.manager > b.manager ? 1 : -1) : Date.parse(b.date) - Date.parse(a.date)
    );

  useEffect(() => {
    mountTableData(tableData);
  }, [tableData]);

  useEffect(() => {
    const filteredItemsModules = tableData
      ? tableData.filter(item => (moduleValue !== 'All' ? item.type.includes(moduleValue) : moduleValue))
      : [];
    const newData = sortData(filteredItemsModules, sortValue);
    mountTableData(newData);
  }, [moduleValue, sortValue]);

  useEffect(() => {
    const filteredItemsMessage = tableData
      ? tableData.filter(item => (messageValue !== 'All' ? item.type.includes(messageValue) : messageValue))
      : [];
    const newData = sortData(filteredItemsMessage, sortValue);
    mountTableData(newData);
  }, [messageValue, sortValue]);

  useEffect(() => {
    const filteredItemsStatus = tableData
      ? tableData.filter(item => (activeValue !== 'All' ? item?.status?.includes(activeValue) : item.status))
      : [];
    const newData = sortData(filteredItemsStatus, sortValue);
    mountTableData(newData);
  }, [activeValue, sortValue]);

  return (
    <>
      <HeaderContainer>
        <DistributionModal isOpen={modalIsOpen} onClose={handleModalClose} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: '16px',
            marginRight: '77px',
          }}
        >
          <RightHeaderContainer1 style={{ marginRight: '16px', width: '250px' }}>
            <HeaderText style={{ marginLeft: '22px' }}>{t('notifications.pageTitle')}</HeaderText>
          </RightHeaderContainer1>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
              <HorizonDropdown label="Message type" options={messageType} setValue={setMessageValue} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
              <HorizonDropdown label="Sort by" options={sortBy} setValue={setSortValue} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
              <HorizonDropdown label="Message" options={module} setValue={setModuleValue} />
            </div>
          </div>
        </div>
      </HeaderContainer>
      <TableContainer>
        <DefaultTable columns={columns} data={items} customStyles={customStyles} />
      </TableContainer>
    </>
  );
};
